import { UserCheck } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useCheckinStats } from '../hooks/useVoting';

/** "X habilitados de Y": people scanned at the door against people who could be enabled */
export function CheckinCounter({ electionId, large = false, className }: { electionId: string; large?: boolean; className?: string }) {
  const { data } = useCheckinStats(electionId);
  if (!data) return null;
  return (
    <p className={cn('inline-flex items-center gap-2', large ? 'text-4xl font-bold' : 'text-sm', className)}>
      <UserCheck className={large ? 'size-9' : 'size-4'} aria-hidden />
      <span>{data.checked_in} habilitados de {data.eligible}</span>
    </p>
  );
}
